import React from 'react';
import { InitializeRouter } from './InitializeRouter';
import { InitializeApp } from './InitializeApp';

export const App = () => (
  <InitializeApp>
    <InitializeRouter />
  </InitializeApp>
);
